<template>
  <div class="contents-box row">
    <h3 class="title-text">{{$t(`service.tab3`)}}</h3>
    <p>{{$t(`service.${txt1}`)}}</p>
    <div class="col-md-5 col-sm-5 prodect-wrap">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
              txt1:'tab3_text',
              imgUrl:require('../../../src/assets/images/b.jpg')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// shealth.vue?3f0e493c